const MAX_EVENTS = 100;

export const types = {
  UPSERT_EVENT: 'UPSERT_EVENT',
  UPSERT_EVENTS: 'UPSERT_EVENTS',
  RESET_EVENTS: 'RESET_EVENTS',
};

const state = {
  events: [],
  lastEventTimestamp: null,
};

export const getters = {
  getTaskEvents: $state => $state.events,
  getLastEventTimestamp: $state => $state.lastEventTimestamp,
};

export const mutations = {
  [types.UPSERT_EVENT]($state, event) {
    if (!event || !event.id) {
      return;
    }

    const existingIndex = $state.events.findIndex(item => item.id === event.id);
    if (existingIndex > -1) {
      $state.events.splice(existingIndex, 1, event);
    } else {
      $state.events.unshift(event);
      if ($state.events.length > MAX_EVENTS) {
        $state.events = $state.events.slice(0, MAX_EVENTS);
      }
    }

    if (event.created_at) {
      $state.lastEventTimestamp = event.created_at;
    }
  },

  [types.UPSERT_EVENTS]($state, events = []) {
    events.forEach(event => {
      mutations[types.UPSERT_EVENT]($state, event);
    });
  },

  [types.RESET_EVENTS]($state) {
    $state.events = [];
    $state.lastEventTimestamp = null;
  },
};

export const actions = {
  handleEvent({ commit }, event) {
    commit(types.UPSERT_EVENT, event);
  },

  replayEvents({ commit }, events = []) {
    commit(types.UPSERT_EVENTS, events);
  },

  reset({ commit }) {
    commit(types.RESET_EVENTS);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
